<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center text-black transition-opacity duration-300 bg-[#0000009e] backdrop-blur-[7px]"
    @click.self="closeModal"
  >
    <div
      class="relative flex flex-col items-center justify-end w-full h-full max-w-full p-6 rounded-lg"
      :class="[$root.hotelCode === 'taigara' ? 'bg-[#455E4C] text-white' : '']"
    >
      <!-- Modal Content -->
      <div class="relative z-10 flex flex-col items-start h-full">
        <!-- Modal Content -->
        <div class="flex flex-col items-center justify-end h-full">
          <loading class="mt-auto mb-auto" v-if="loading"></loading>
          <VoiceAnimation v-if="!loading" :isSpeaking="isSpeaking" />

          <section class="w-full">
            <SessionControls
              :start-session="startSession"
              :stop-session="stopSession"
              :send-client-event="sendClientEvent"
              :server-events="events"
              @close-modal="closeModal"
            />
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/article/ArticleLoading.vue"
import SessionControls from "./SessionControls.vue"
import VoiceAnimation from "./VoiceAnimation.vue"

export default {
  name: "VoiceAiWrapper",
  components: {
    SessionControls,
    VoiceAnimation,
    Loading,
  },
  data() {
    return {
      isOpen: false,
      events: [],
      dataChannel: null,
      peerConnection: null,
      audioElement: null,
      isSpeaking: false,

      loading: false,
    }
  },
  watch: {
    dataChannel(newDataChannel) {
      if (newDataChannel) {
        newDataChannel.addEventListener("message", (e) => {
          const event = JSON.parse(e.data)
          if (!event.timestamp) {
            event.timestamp = new Date().toLocaleTimeString()
          }
          this.events = [event, ...this.events]
        })

        newDataChannel.addEventListener("open", async () => {
          this.setPrompt()
        })
      }
    },

    isOpen(val) {
      this.$root.freezeActivePageScroll(val)
    },
  },
  methods: {
    async openModal() {
      this.isOpen = true

      this.loading = true
      await this.startSession()
      this.loading = false
    },

    closeModal() {
      this.stopSession()
      this.isOpen = false
    },

    async startSession() {
      try {
        const tokenResponse = await fetch(
          `${process.env.VUE_APP_OPENAI_URL}token`
        )
        const data = await tokenResponse.json()
        const EPHEMERAL_KEY = data.client_secret.value

        const pc = new RTCPeerConnection()
        this.audioElement = document.createElement("audio")
        this.audioElement.autoplay = true
        pc.ontrack = (e) => {
          const stream = e.streams[0]
          this.audioElement.srcObject = stream

          const audioContext = new (window.AudioContext ||
            window.webkitAudioContext)()
          const source = audioContext.createMediaStreamSource(stream)
          const analyser = audioContext.createAnalyser()
          const dataArray = new Uint8Array(analyser.frequencyBinCount)

          source.connect(analyser)

          const checkSpeaking = () => {
            analyser.getByteFrequencyData(dataArray)
            const volume =
              dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length

            // Threshold to decide speaking
            if (volume > 10) {
              if (!this.isSpeaking) this.isSpeaking = true
            } else {
              if (this.isSpeaking) this.isSpeaking = false
            }

            requestAnimationFrame(checkSpeaking)
          }

          checkSpeaking()
        }

        const ms = await navigator.mediaDevices.getUserMedia({
          audio: true,
        })
        pc.addTrack(ms.getTracks()[0])

        const dc = pc.createDataChannel("oai-events")
        this.dataChannel = dc

        const offer = await pc.createOffer()
        await pc.setLocalDescription(offer)

        const baseUrl = "https://api.openai.com/v1/realtime"
        const model = "gpt-4o-mini-realtime-preview-2024-12-17"
        const voice = "shimmer"
        const sdpResponse = await fetch(
          `${baseUrl}?model=${model}&voice=${voice}`,
          {
            method: "POST",
            body: offer.sdp,
            headers: {
              Authorization: `Bearer ${EPHEMERAL_KEY}`,
              "Content-Type": "application/sdp",
            },
          }
        )

        const answer = {
          type: "answer",
          sdp: await sdpResponse.text(),
        }
        await pc.setRemoteDescription(answer)

        this.peerConnection = pc
      } catch (error) {
        console.error("Error starting session:", error)
      }
    },

    async setPrompt() {
      try {
        const response = await fetch(
          process.env.VUE_APP_API_URL +
            "public/chat/gpt-prompt/" +
            this.$root.hotel.uuid
        )
        const result = await response.json()

        if (result.success && Array.isArray(result.data)) {
          console.log(result.data)
          result.data.forEach((item) => {
            console.log("item", item)
            let systemPrompt = {
              type: "conversation.item.create",
              item: {
                type: "message",
                role: item.role || "system",
                content: [
                  {
                    type: "input_text",
                    text: item.content,
                  },
                ],
              },
            }
            this.sendClientEvent(systemPrompt)
          })
        } else {
          console.warn("Prompt API failed or returned no data:", result)
        }
      } catch (err) {
        console.error("Failed to fetch system prompts:", err)
      }
    },

    stopSession() {
      if (this.dataChannel) {
        this.dataChannel.close()
      }

      if (this.peerConnection) {
        this.peerConnection.getSenders().forEach((sender) => {
          if (sender.track) {
            sender.track.stop()
          }
        })
        this.peerConnection.close()
      }

      this.dataChannel = null
      this.peerConnection = null
      this.audioElement = null
    },

    sendClientEvent(message) {
      if (!this.dataChannel)
        console.error(
          "Failed to send message - no data channel available",
          message
        )

      const timestamp = new Date().toLocaleTimeString()
      message.event_id = message.event_id || crypto.randomUUID()
      this.dataChannel.send(JSON.stringify(message))
      if (!message.timestamp) {
        message.timestamp = timestamp
      }
      this.events = [message, ...this.events]
    },
  },
}
</script>

<style scoped></style>
